/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAddLink = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M19.07 12A5 5 0 1 0 12 4.929L9.17 7.757l1.415 1.415 2.828-2.829a3 3 0 1 1 4.243 4.243l-2.829 2.828 1.415 1.414zM4.929 12a5 5 0 0 0 7.07 7.071l2.83-2.828-1.415-1.415-2.828 2.829a3 3 0 1 1-4.243-4.243l2.828-2.828-1.414-1.414z" />
        <path d="m16.242 9.172-7.07 7.07-1.415-1.414 7.071-7.07zM19 16v3h-3v2h3v3h2v-3h3v-2h-3v-3z" />
      </g>
    </g>
  </Icon>
);
export { SvgAddLink as AddLink };
